import React, { useState, useContext, useEffect, useCallback } from 'react';
import * as CalcConstants from '../../../constants/MiniCalcConstants';

import { CALC_TOKENS } from '../../../constants/Languages';
import layoutContext from '../../layoutContext';

import MiniCalcRange from './MiniCalcRange';
import MiniCalcHeader from './MiniCalcHeader';
import Modal from '../../Calculator/Modal';

/*const COUNTER = 'counter';
const GET_PARAMS = 'getParams';*/

import './MiniCalc.scss';

const MiniCalc = () => {
  const { cult } = useContext(layoutContext);
  const {
    miniCalcTitle,
    summ,
    duration,
    getMoney,
    repetitiveCredit, } = CALC_TOKENS[cult];
  const {
    START_SUMM,
    MAX_DAYS,
    MIN_LOAN,
    MAX_LOAN,
    LOAN_STEP,
    MIN_DAYS,
    DAYS_STEP, } = CalcConstants;
  const [loan, setLoan] = useState(START_SUMM);
  const [days, setDays] = useState(MAX_DAYS);
  const [isModalOpen, openModal] = useState(false);

  useEffect(() => {
    let summRange = null, badge = null;
    function inputListener() {
      if (+summRange.value > 5000) {
        badge.classList.add('shown');
      } else {
        badge.classList.remove('shown');
      }
      const x =
        summRange.offsetLeft - badge.offsetWidth / 2 +
        Math.round(
          summRange.clientWidth * (+summRange.value / +summRange.max)
        );
      badge.style.left = `${x}px`;

      if (+summRange.value > 6000 && +summRange.value > 7500) {
        badge.style.left = `${x - 5}px`;
      }
      if (+summRange.value > 10000) {
        badge.style.left = `${x - 10}px`;
      }

      if (+summRange.value > 13500) {
        badge.style.left = `${x - 15}px`;
      }
    }
    function blurListener() {
      badge.classList.remove('shown');
    }

    summRange = document.querySelector('.mini-calc-range');
    badge = document.querySelector('#mini-calc-summ-badge');
    badge.style.top = `${45}px`;
    summRange.addEventListener('input', inputListener);
    summRange.addEventListener('blur', blurListener);
    inputListener();
    return () => {
      summRange.removeEventListener('input', inputListener);
      summRange.removeEventListener('blur', blurListener);
    };
  }, []);

  /*const getCookie = useCallback(
    (name) => {
      if (typeof document !== 'undefined') {
        const value = `; ${window.document.cookie}`;
        const parts = value.split(`; ${name}=`);
        const data = parts.pop().split(';').shift();
        const getParams = data != '' ? JSON.parse(data) : {};

        return Object.keys(getParams).reduce((url, current) => {
          return `${url}&${current}=${getParams[current]}`;
        }, '');
      }
    },
    [],
  );*/

  /*const gtmPush = useCallback(
    (type) => {
      if (typeof window !== undefined) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'eventCategory': 'form',
          'eventAction': 'sent',
          'eventLabel': type,
          'eventNonInteraction': 'False',
          'event': 'autoEvent'
        });
      }
    },
    [],
  );*/


  const fixMenu = useCallback(
    () => document.getElementsByTagName('body')[0].classList.toggle('fixed'),
    [],
  );

  return (
    <>
      <div className='mini-calc'>
        <MiniCalcHeader title={miniCalcTitle} />
        <div className='mini-calc-body'>
          <MiniCalcRange
            value={loan}
            setValue={setLoan}
            min={MIN_LOAN}
            max={MAX_LOAN}
            step={LOAN_STEP}
            id='mini-calc-loan'
            name={summ}
            units='грн.'
          />
          <MiniCalcRange
            value={days}
            setValue={setDays}
            min={MIN_DAYS}
            max={MAX_DAYS}
            step={DAYS_STEP}
            id='mini-calc-days'
            name={duration}
            units='дн.'
          />
          <div className='mini-calc-btn-container'>
            <a
              className='btn btn-primary modal-btn' target={'_blank'}
              rel={'noreferrer'}
              href={
                'https://bit.ly/3wSe59r'
              }
            >{getMoney}</a>
          </div>
        </div>
        <div id='mini-calc-summ-badge'>{repetitiveCredit}</div>
      </div>
      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          openModal={openModal}
          fixMenu={fixMenu}
          sum={loan}
          days={days}
        />
      )}
    </>
  );
};

export default MiniCalc;
